import React from 'react';
import { useTranslation } from 'react-i18next';
import { 
  Select, 
  MenuItem, 
  FormControl,
  Box
} from '@mui/material';
import type { SelectChangeEvent } from '@mui/material';

export const LanguageSwitcher: React.FC = () => {
  const { i18n, t } = useTranslation();

  // Only support 'ko' and 'en' - default to 'en' for anything else
  const currentLanguage = i18n.language === 'ko' ? 'ko' : 'en';

  // Ensure language is properly set on mount
  React.useEffect(() => {
    if (i18n.language !== 'ko' && i18n.language !== 'en') {
      i18n.changeLanguage('en');
    }
  }, [i18n]);

  const handleChange = (event: SelectChangeEvent) => {
    i18n.changeLanguage(event.target.value);
  };

  return (
    <Box sx={{ position: 'fixed', top: 16, right: 16, zIndex: 1100 }}>
      <FormControl size="small">
        <Select
          value={currentLanguage}
          onChange={handleChange}
          sx={{
            minWidth: 120,
            height: 32, // Match Chip height from ConnectionStatus
            backgroundColor: 'rgba(0, 255, 255, 0.1)',
            backdropFilter: 'blur(10px)',
            color: 'primary.main',
            border: '1px solid',
            borderColor: 'primary.main',
            '& .MuiOutlinedInput-notchedOutline': {
              border: 'none',
            },
            '&:hover': {
              backgroundColor: 'rgba(0, 255, 255, 0.2)',
            },
            '& .MuiSelect-icon': {
              color: 'primary.main',
            },
          }}
        >
          <MenuItem value="en">
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <span>🇺🇸</span>
              <span>{t('language.english')}</span>
            </Box>
          </MenuItem>
          <MenuItem value="ko">
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <span>🇰🇷</span>
              <span>{t('language.korean')}</span>
            </Box>
          </MenuItem>
        </Select>
      </FormControl>
    </Box>
  );
};